import React from 'react'
import { withStyles, Table, TableHead, TableBody } from '@material-ui/core';
import PropTypes from 'prop-types';
import clsx from 'clsx';

const style = theme => ({
	table: {
		tableLayout: 'fixed',

		'& td, th': {
			overflow: 'hidden',
		}
	}
});

function STableContainer({
	classes,
	children,
	head,
	className,
}) {
	return (
		<Table className={clsx(
			classes.table,
			className,
		)}>
			<TableHead>
				{head}
			</TableHead>
			<TableBody>
				{children}
			</TableBody>
		</Table>
	)
}

STableContainer.propTypes = {
	classes: PropTypes.any,
}

export default withStyles(style)(STableContainer);